<script setup lang="ts">
import { countryByTz } from '@shared/config'
import { PhoneInput } from '@shared/ui/input'

import { useTutorApplicationStore } from '../../model/store'
import { usePhone } from '../../model/personal-information/phone.hooks'

defineOptions({
  name: 'InputPhone',
})

const tutorApplicationStore = useTutorApplicationStore()

const {
  mode,
  setPhone,
} = usePhone()

</script>

<template>
  <div class="input-phone">
    <PhoneInput
      id="phone"
      name="phone"
      label="Phone number"
      :required="true"
      :value="tutorApplicationStore.form.phoneNumber"
      :country-by-tz="countryByTz"
      :mode="mode"
      invalid-msg="Please enter your phone number"
      info="🔍 Please make sure you leave your phone number in the international format"
      @change="setPhone"
    />
  </div>
</template>

<style scoped lang="scss" src="./InputPhone.scss" />
